import http from "@/service";
import type { UserItem } from "@/types/system/user";
import type { CommonList } from "@/types";

const api = {
  dict: "/pac-system/common/option",
  getDictListByCode: "/pac-system/dict/dictionary",
  getUserInfo: "/pac-system/user/info",
  commonUploadFile: "pac-system/file/upload",
  commonDownloadFile: "pac-system/file/download",
  downloadTemplate: "/pac-affiliate/template/download?templateName=",
  getFileInfoByIds: "/pac-system/file/listByIds",
  getCmUserOption: "/pac-system/common/option/list/cm-users",
  getToUserOption: "pac-system/common/option/list/to-users",
  getFileUrlByFileId: "/pac-system/file/generatePreSignedUrl",
  getSystemActionLog: "/pac-system/sys-opt/logs/page",
  getCmUserOptionInNewVersion: "/pac-system/common/option/list/cm-users/v2", // 新版本获取cm用户选项
  getCmUserOptionV3: "/pac-system/common/option/list/cm-users/v3" //cm用户可获取所有cm用户
};

export function fetchDictValueForSelect<T = any>(
  name: string,
  language?: string
) {
  return http.get<T>(api.dict, {
    params: { name, language }
  });
}

interface DictListItem {
  code: string;
  dictKey: string;
  dictValue: string;
  id: string;
  isSealed: string;
  parentId: string;
  remark: string;
  sort: number;
}

export function fetchDictListByCode(code: string) {
  return http.get<DictListItem[]>(api.getDictListByCode, {
    params: { code }
  });
}

export function getUserInfo() {
  return http.get<UserItem>(api.getUserInfo);
}

export function commonUploadFile(files: File) {
  return http.post(
    api.commonUploadFile,
    { files },
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
}

export function commonDownloadFile(ids: string) {
  return http.get<Blob>(api.commonDownloadFile, {
    params: { ids },
    responseType: "blob"
  });
}

export function downloadTemplate(name: string) {
  return http.get<Blob>(api.downloadTemplate + name, {
    responseType: "blob"
  });
}

interface FileInfoType {
  createDept: string;
  createTime: string;
  creator: number;
  domainUrl: string;
  extension: string;
  fileSize: number;
  id: number;
  link: string;
  name: string;
  originalName: string;
  updateTime: string;
  updater: number;
}
export function getFileInfoByIds(ids: string) {
  return http.get<FileInfoType[]>(api.getFileInfoByIds, { params: { ids } });
}

export function getCmUserOption() {
  return http.get<{ text: string; value: string }[]>(api.getCmUserOption);
}

export function getToUserOption(isToOnlyOneself: number, affiliateId?: string) {
  return http.get<{ text: string; value: string }[]>(api.getToUserOption, {
    params: { isToOnlyOneself, affiliateId }
  });
}

export function getFileUrlByFileId(ids: string) {
  return http.get<Record<string, string>>(api.getFileUrlByFileId, {
    params: { ids }
  });
}

export function getSystemActionLog(params: any) {
  return http.get<CommonList<any>>(api.getSystemActionLog, {
    params
  });
}

export function getCmUserOptionInNewVersion() {
  return http.get<{ text: string; value: string }[]>(
    api.getCmUserOptionInNewVersion
  );
}

export function getCmUserOptionV3() {
  return http.get<{ text: string; value: string }[]>(api.getCmUserOptionV3);
}
